import { ApplicationActionType } from './actions';
const defaultApplicationState = {
    isLoggingOut: false,
    softResetApplication: false
};
export function applicationResetReducers(state = defaultApplicationState, action) {
    const { type } = action;
    switch (type) {
        case ApplicationActionType.HardReset:
            return Object.assign(Object.assign({}, defaultApplicationState), { isLoggingOut: true });
        case ApplicationActionType.Reset:
            return Object.assign(Object.assign({}, state), { softResetApplication: true });
        case ApplicationActionType.ResetComplete:
            return Object.assign(Object.assign({}, state), { softResetApplication: false });
        case ApplicationActionType.SoftReset:
            return Object.assign({}, defaultApplicationState);
        default:
            return state;
    }
}
